import { SortingRule } from "react-table";
import { map } from "rxjs/operators";
import { GET, POST, PUT } from "../../../../module/services/fetch";
import { INotify, INotifyCall } from "./constants";

export const getNotifications = (
  body: INotifyCall,
  sortBy: SortingRule<{}>[]
) => {
  return POST(
    `admin/users/messages/all?${
      sortBy && sortBy.length > 0
        ? `sortField=${sortBy[0].id}&sortOrder=${
            sortBy[0].desc ? "desc" : "asc"
          }`
        : ""
    }`,
    body
  ).pipe(map((res: any) => res));
};

export const getAllRoles = () => {
  return GET("authentication/admin/view-roles").pipe(map((res: any) => res));
};

export const postNotify = (data: INotify) => {
  return POST("admin/users/messages", [data]).pipe(map((res: any) => res));
};

export const putNotify = (data: INotify) => {
  return PUT("admin/users/messages", [data]).pipe(map((res: any) => res));
};

export const deleteNotify = (id: string) => {
  return POST("admin/users/messages/delete", [id]).pipe(map((res: any) => res));
};
